import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const LoginRequiredModal = ({ show, onLogin }) => {
  const { t } = useTranslation();
  return (
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title>{t('login_required')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t('login_required_message')}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onLogin}>{t('login')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LoginRequiredModal; 